import app, { Component } from 'apprun';
import { users as userApi } from './api';
import { showSaveStatusMessage } from './utils';

const Item = ({ item, caller }) => (
  <tr class="hand">
    <td>
      <a>{item.name}</a>
    </td>
    <td>
      <a>{item.employeeType}</a>
    </td>
    <td>
      <a>{item.numOfDaysSinceTermination}</a>
    </td>
    <td>
      <input
        type="checkbox"
        id={'cbxApprove_' + item.googleDeleteStagingID}
        name={'cbxApprove_' + item.googleDeleteStagingID}
        checked={item.approved ? 'checked' : null}
        onclick={e => caller.run('toggleApprove', e, item.googleDeleteStagingID)}
      />
    </td>
  </tr>
);

const List = ({ items, caller }) => (
  <table class="table table-striped table-condensed table-bordered table-hover">
    <thead>
      <tr>
        <th>Name</th>
        <th>EmployeeType</th>
        <th>Days Since Termination</th>
        <th>Approve</th>
      </tr>
    </thead>
    <tbody>
      {items.map(item => (
        <Item item={item} caller={caller} />
      ))}
    </tbody>
  </table>
);

export default class GoogleDeleteListComponent extends Component {
  state = {
    users: [],
    googleDeleteList: [],
    filter: ''
  };

  view = (state) => {
    if (!state || !state.users) {return;}
    //  const googleDeleteList = !state.filter
    //   ? state.googleDeleteList
    //  : state.googleDeleteList.filter(c => (c.firstName.toUpperCase() + ' ' + c.lastName.toString()).indexOf(state.filter.toUpperCase()) >= 0) ;

    return (
      <div style={{ width: '500px' }}>
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Search..."
            oninput={e => this.run('search', e)}
            value={state.filter || ''}
          />
          Select All{' '}
          <input id="cbxSelectAll" name="cbxSelectAll" type="checkbox" onchange={() => this.run('toggleSelectAll')} />
        </div>
        <List items={state.users} caller={this} />
        <p class="text-danger">PLEASE DOUBLE CHECK BEFORE CLICKING ON APPROVE</p>
        <a class="btn btn-primary btn-xs" onclick={() => this.run('approve')}>
          Approve
        </a>
      </div>
    );
  };

  update = {
    refresh: async (state) => {
      if (!state.googleDeleteList.length) {
        const googleDeleteList = await userApi.getGoogleDeleteList();
        return { ...state, users: googleDeleteList, googleDeleteList };
      } else {
        return state;
      }
    },
    toggleSelectAll: (state) => {
      state.googleDeleteList.forEach(k => k.approved = !k.approved);
      return state;
    },
    approve: async (state) => {
      try{
        const itemsForApproval = state.googleDeleteList.filter(k => k.approved === true);
        const idList = itemsForApproval.map(p => p.googleDeleteStagingID);
        await userApi.approveGoogleDelete(idList);
        showSaveStatusMessage('GoogleDelete');
      }catch{
        showSaveStatusMessage();
      }
      this.run('refresh');
      return state;
    },
    toggleApprove: (state, e, id) => {
      state.googleDeleteList.map((k) => {
        k.approved = k.googleDeleteStagingID === id ? !k.approved : k.approved;
      });
      return state;
    },
    search: (state, e) => {
      state.filter = e.target.value;
      state.users = state.googleDeleteList.filter(u => u.name.toUpperCase().indexOf(state.filter.toUpperCase()) >= 0);
      return state;
    }
  };

  mounted = () => {
    this.run('refresh');
  };
}
